export default "__VITE_ASSET__D07z7gEd__"